<template>
  <transition
    name="fade"
    :style="{
      transitionDuration: `${props.duration}ms`
    }"
  >
    <slot />
  </transition>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    duration?: number
  }>(),
  {
    duration: 300
  }
)
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
